import gsap from 'gsap'
import { introHomepage } from './bundle'

class Loader{
    constructor(){
        this.loader = document.querySelector('.villa-loader')
        this.loaderLogo = document.querySelector('.loader__logo')
        this.fakeLogo = this.loader.querySelector('.fake')
        this.realLogo = this.loader.querySelector('.real')

        this.svgGroupsFake = [...this.fakeLogo.querySelectorAll('g')]     
        this.realItems = [...this.loader.querySelectorAll('.real__item')]     

        this.svgBg = document.querySelector('.loader__bg__svg-sipario__path')

        setTimeout(() => {
            this.initEvents()
        },1500)

    }

    initEvents(){
        this.setDimensions()
        this.animateLogo().
            then( () => {
                this.exitLogo()
                this.exitBackground().then( () => {
                    this.loader.style.display = 'none'
                })
                introHomepage()
            })
    }

    setDimensions(){
		this.realLogo.style.width = this.fakeLogo.getBoundingClientRect().width + 'px'
		this.realLogo.style.height = this.fakeLogo.getBoundingClientRect().height + 'px'
        this.svgGroupsFake.forEach( g => {
            const rect = g.getBoundingClientRect()
            // const top = rect.top
            const groupClass = g.classList.value
            const cleanClass = groupClass.replace('svg-group--','')
            // if(cleanClass !== 'curve'){
                // console.log(rect.top)
                // console.log(this.realLogo.querySelector('.'+cleanClass))
                this.realLogo.querySelector('.'+cleanClass).style.top = rect.top + 'px'
                this.realLogo.querySelector('.'+cleanClass).style.left = rect.left + 'px'
                this.realLogo.querySelector('.'+cleanClass).style.width = rect.width + 'px'
                this.realLogo.querySelector('.'+cleanClass).style.height = rect.height + 'px'
            // }
        })  
    }
    animateLogo(){
        return new Promise( resolve => {  
            this.realItems.forEach( item => item.classList.add('active'))
            setTimeout( () => {
                resolve()
            }, 1800)
        })
    }

    exitLogo(){
        gsap.to(this.loaderLogo,{
            duration: 1.7,
            y: '-100%',
            ease: 'power2.inOut'
        })
    }

    exitBackground(){
        return new Promise( resolve => {
            const timelineDelay = 0.2;
            gsap.
            timeline({delay: timelineDelay})
                  .set(this.svgBg, {
                        attr: { d: "M 0 0 V 100 Q 50 100 100 100 V 0 z" }
                    })
                    .to(
                      this.svgBg,
                      {
                          attr: { d: "M 0 0 V 35 Q 50 0 100 35 V 0 z" },
                          ease: "power1.in",
                          duration: 0.8
                      }
                    )
                    .to(
                      this.svgBg,
                      {
                          attr: { d: "M 0 0 V 0 Q 50 0 100 0 V 0 z" },
                          ease: "power2.out",
                          duration: 0.8,
                          onComplete: () => {
                            //reset svg gold
                            resolve()
                            gsap.set(this.svgBg,{
                                attr: { d: "M 0 100 V 100 Q 50 100 100 100 V 100 z" },
                                // delay:1.2
                            })
                          }
                      }
                    )        
        })
    }


}


export {Loader}